import { styled, Text, TokenTextAppearance, TokenTextColor } from "@volkswagen-onehub/components-core";
import React from "react";
import { formatCurrency } from "../../app.utils";
import { LanguageType } from "../../types/data";

const ToolTipBrand = styled.div<{isVw?: boolean}>`
  padding: 0 2px;
  color: ${(props) => (props.isVw ? '#00437A' : '#000')};
  border: 2px solid ${(props) => (props.isVw ? '#00437A' : 'transparent')};
`;

interface Props {
  payloadSorted: any;
  language: LanguageType;
}

export const CustomTooltipData = ({payloadSorted, language}: Props) => {
  return (
    payloadSorted.map((pld: any) => {
      const pldMapped = JSON.parse(pld.name);
      const text = `${pldMapped.make} ${formatCurrency(pld.value, language)}`;
      return (
        <li key={pld.name}>
          <ToolTipBrand isVw={pldMapped.make == 'Volkswagen'}>
            <Text
              appearance={TokenTextAppearance.copy100}
              bold={pldMapped.make == 'Volkswagen'}
              color={TokenTextColor.inherit}
            >
              { text }
            </Text>
          </ToolTipBrand>
        </li>
      );
    })
  )

};
